import { formatARS } from "../lib/money";
import type { ProductVisualKey } from "@ventas/shared";
import { ProductThumbnail } from "./CatalogVisuals";

type Props = {
  name: string;
  category?: string;
  categoryId?: number | null;
  visualKey?: ProductVisualKey | null;
  suggestedPriceCents?: number;
  linesCount: number;
  onAdd: () => void;
};

export function ProductTile({ name, category, categoryId, visualKey, suggestedPriceCents, linesCount, onAdd }: Props) {
  const selected = linesCount > 0;
  return (
    <article
      className={`product-tile${selected ? " is-selected" : ""}`}
      role="group"
      aria-label={`${name}, ${linesCount} en venta`}
    >
      <button
        className="product-tile__body"
        type="button"
        aria-label={`Agregar ${name}`}
        onClick={onAdd}
      >
        <span className="product-tile__top">
          <ProductThumbnail productName={name} categoryName={category} categoryId={categoryId} visualKey={visualKey} />
          {selected && (
            <span className="product-tile__badge" aria-hidden="true">
              {linesCount}
            </span>
          )}
        </span>
        <span className="product-tile__name">{name}</span>
      </button>
      {suggestedPriceCents !== undefined && (
        <span className="num product-tile__price">{formatARS(suggestedPriceCents)}</span>
      )}
      {/* Sibling of .product-tile__body (not nested) to avoid an invalid
          <button> inside a <button>. .product-tile__body already adds the
          product on click and carries the "Agregar {name}" accessible name,
          so this "+" is a sighted-only visual affordance: hidden from the
          accessibility tree and removed from the tab order to avoid a
          duplicate "Agregar {name}" stop right after the body button. */}
      <button
        type="button"
        className="product-tile__add"
        aria-hidden="true"
        tabIndex={-1}
        onClick={onAdd}
      >
        +
      </button>
      <span className="sr-only" aria-live="polite">
        {selected ? `${linesCount} ${linesCount === 1 ? "unidad" : "unidades"} en venta` : ""}
      </span>
    </article>
  );
}
